/* Nous contacter : met le focus sur le résumé d'erreurs ou sur la confirmation, pour qu'ils soient annoncés. */
(function () {
  var cible = document.querySelector('[data-contact-focus]');
  if (!cible) return;
  cible.focus();
  cible.scrollIntoView({ block: 'center' });
})();
